import { RoleLookupDto } from './role-lookup.dto';

export class RoleLookup {
    id: string;
    name: string;
    requiresDepartment: boolean;

    constructor(dto: RoleLookupDto) {
        this.id = dto.id;
        this.name = dto.name;
        this.requiresDepartment = dto.requiresDepartment;
    }
}
